import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { BoothService } from '../booth.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { GlobalService } from 'src/app/global.service';
import { FormControl } from '@angular/forms';
import { MatPaginator, ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-booth-table',
  templateUrl: './booth-table.component.html',
  styleUrls: ['./booth-table.component.scss']
})
export class BoothTableComponent implements OnInit {

  nameFilter = new FormControl('');
  codeFilter = new FormControl('');
  pincodeFilter = new FormControl('');
  businessTypeFilter = new FormControl('');
  zoneFilter = new FormControl('');
  mor_filter = new FormControl('');
  eve_filter = new FormControl('');
  filterValues = {
    'id': '',
    'name': '',
    'code': '',
    'mor_route': '',
    'eve_route': '',
    'zone': '',
    'business_type': '',
    'pincode': ''
  };

  // loader
  data_loaded = false;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 100;

  // title = null;
  displayedColumns: string[] = ['code', 'id', 'name', 'zone', 'business_type', 'pincode', 'mor_route', 'eve_route'];
  dataSource: any = null;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  title = 'Booth Type';

  constructor(private http: HttpService, public boothService: BoothService, private global: GlobalService) {
    this.getBooths();
    this.title = this.global._active_display_name;

    this.boothService.downloadBooth.subscribe((is_update_zone) => {
      console.log(is_update_zone);
      if (is_update_zone) {
        this.getBooths();
      }
    });
    this.global.set_master_page_title = 'Booth';
  }

  showBoothRegister() {
    this.boothService.is_display_booth_register_component = true;
  }

  hideBoothRegister() {
    this.boothService.is_display_booth_register_component = false;
  }

  registerBooth() {
    this.showBoothRegister();
    console.log('register zone');
    this.boothService.boothUpdate.emit(null);
    this.boothService.set_booth_data = null;
  }

  editBooth(booth) {
    this.showBoothRegister();
    console.log(booth);
    this.boothService.boothUpdate.emit(booth);
    this.boothService.set_booth_data = booth;
  }

  getBooths() {
    this.http.getBooths().subscribe((data: Booth[]) => {
      this.dataSource = data;
      console.log(data);
      this.dataSource = new MatTableDataSource<Booth>(data);
      this.dataSource.sort = this.sort;
      this.dataSource.data = data;
      // this.dataSource.paginator = this.paginator;
      this.dataSource.filterPredicate = this.createFilter();
    }, (error) => {
      console.log(error);
    });
  }

  ngOnInit() {
    console.log('ng funct');
    this.nameFilter.valueChanges
      .subscribe(
        name => {
          this.filterValues.name = name;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
    // code
    this.codeFilter.valueChanges
      .subscribe(
        code => {
          this.filterValues.code = code;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
    // pincode
    this.pincodeFilter.valueChanges
      .subscribe(
        pincode => {
          this.filterValues.pincode = pincode;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
    this.businessTypeFilter.valueChanges
      .subscribe(
        business_type => {
          this.filterValues.business_type = business_type;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
    this.mor_filter.valueChanges
      .subscribe(
        mor_route => {
          this.filterValues.mor_route = mor_route;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
    this.zoneFilter.valueChanges
      .subscribe(
        zone => {
          this.filterValues.zone = zone;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
    this.eve_filter.valueChanges
      .subscribe(
        eve_route => {
          this.filterValues.eve_route = eve_route;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
  }

  createFilter():
    (data: any, filter: string) => boolean {
    console.log('filter')
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.code.toLowerCase().indexOf(searchTerms.code.toString().toLowerCase()) !== -1
        && data.name.toString().toLowerCase().indexOf(searchTerms.name.toString().toLowerCase()) !== -1
        && data.business_type.toString().toLowerCase().indexOf(searchTerms.business_type.toString().toLowerCase()) !== -1
        && data.zone.toString().toLowerCase().indexOf(searchTerms.zone.toString().toLowerCase()) !== -1
        && data.pincode.toString().toLowerCase().indexOf(searchTerms.pincode) !== -1
        && data.mor_route.toString().toLowerCase().indexOf(searchTerms.mor_route) !== -1
        && data.eve_route.toString().toLowerCase().indexOf(searchTerms.eve_route) !== -1;
    }
    return filterFunction;
  }

}

export interface Booth {
  id: number;
  name: string;
}

